import { useAppDispatch, useAppSelector } from "../redux/redux.hook";
import { useCallback } from "react";
import { getNotFoundData } from "./notFound.thunk";
import { resetNotFound } from "./notFound.slice";
import { isLoading, isSuccess, isError } from "@/app/utils/asyncStatus";

const useNotFound = () => {
  const dispatch = useAppDispatch();
  const { data, status, error, currentSlug } = useAppSelector(
    (store) => store.notFound
  );

  const fetchNotFound = useCallback(
    async (slug: string) => {
      const result = await dispatch(getNotFoundData(slug));
      return result.meta.requestStatus === "fulfilled";
    },
    [dispatch]
  );

  const reset = useCallback(() => {
    dispatch(resetNotFound());
  }, [dispatch]);

  return {
    notFoundData: data,
    currentSlug,
    error,
    status,
    isLoading: isLoading(status),
    isSuccess: isSuccess(status),
    isError: isError(status),
    fetchNotFound,
    reset,
  };
};

export default useNotFound;
